import React, { useEffect, useState, useRef } from "react";
import styles from "../EditPublic/EditPublic.module.css";
import stepStyles from "../Step/Step.module.css";
import EditHeader from "../EditHeader/EditHeader";
import SectionHeader from "../SectionHeader/SectionHeader";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import { useNavigate, useLocation } from "react-router-dom";
import { listSiteMap, validateWebsite } from "../../Store/apiStore";
import Loader from "../Loader/Loader";
import decodeToken from "../../lib/decodeToken";
import { useAgentCreator } from "../../hooks/useAgentCreator";
import PopUp from "../Popup/Popup";
import { useDashboardStore } from "../../Store/agentZustandStore";
import Modal2 from "../Modal2/Modal2";
import CustomAutoSearch from "../CustomAutocomplete/CustomAutoSearch";
import filterCompanyPages from "../../utils/companyKeyboards";

// Match AboutBusiness behaviour: enforce https:// (no www)
const HTTPS_PREFIX = "https://";
const PREFIX_LEN = HTTPS_PREFIX.length;

const EditPublic = () => {
  const agentnm = sessionStorage.getItem("agentName");
  const stepEditingMode = localStorage.getItem("UpdationModeStepWise");
  const EditingMode = localStorage.getItem("UpdationMode");
  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const [userId, setUserId] = useState(decodeTokenData?.id || "");
  const navigate = useNavigate();
  const location = useLocation();
  const [placeDetails, setPlaceDetails] = useState(null);
  const [originalForm, setOriginalForm] = useState(null);
  const [currentForm, setcurrentForm] = useState(null);

  const [loading, setLoading] = useState(true);
  const [googleListing, setGoogleListing] = useState("");
  const [displayBusinessName, setDisplayBusinessName] = useState(
    sessionStorage.getItem("displayBusinessName")
  );
  const [businessUrl, setBusinessUrl] = useState("");
  const [noGoogleListing, setNoGoogleListing] = useState(false);
  const [noBusinessWebsite, setNoBusinessWebsite] = useState(false);
  const [businessUrlError, setBusinessUrlError] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [urlVerificationInProgress, setUrlVerificationInProgress] =
    useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
  const { setHasFetched } = useDashboardStore();
  const [showSiteMapUrls, setShowSiteMapUrls] = useState([]);
  const [selectedUrls, setSelectedUrls] = useState([]);
  const [addOnUrl, setAddOnUrl] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const previousBusinessUrlRef = useRef("");
  const [googleResults, setGoogleResults] = useState([]);
  const [showNoGMBCheckbox, setShowNoGMBCheckbox] = useState(false);
  const [businessDetailsConfirmPopup, setBusinessDetailsConfirmPopup] =
    useState(false);
  const [businessDetails, setBusinessDetails] = useState(null);
  const [disableLoading, setDisableLoading] = useState(false);
  const [hasValidatedWebsite, setHasValidatedWebsite] = useState(false);
  const [hasFetchedSitemap, setHasFetchedSitemap] = useState(false);

  const fetchGoogleResults = (text) => {
    if (!window.google?.maps?.places) return;

    if (!text) {
      setGoogleResults([]);
      return;
    }

    const service = new window.google.maps.places.AutocompleteService();
       service.getPlacePredictions({ input: text, types: ['establishment'] }, (predictions) => {
      setGoogleResults(predictions || []);
    });
  };

  // Refs for autofill logic (mirrors AboutBusiness)
  const prevPlaceIdRef = useRef(null);
  const lastAutoFilledUrlRef = useRef("");
  const typingTimeoutRef = useRef(null);
  const inputRefWebSiteUrl = useRef(null);
  const shouldFocusBackRef = useRef(false);
  const noBusinessWebsiteRef = useRef(noBusinessWebsite);
  const listRef = useRef(null);
  useEffect(() => {
    noBusinessWebsiteRef.current = noBusinessWebsite;
  }, [noBusinessWebsite]);

  useEffect(() => {
    if (!noBusinessWebsite && businessUrl) {
      previousBusinessUrlRef.current = businessUrl;
    }
  }, [businessUrl, noBusinessWebsite]);
  // 🔹 Place se website pick karke auto validate + sitemap
  const autoHandleWebsiteFromPlace = async (place) => {
    try {
      const rawWebsite = place?.website;
      let aboutBusinessForm = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );

      // Agar is business ke GMB me website hi nahi hai
      if (!rawWebsite) {
        aboutBusinessForm.noBusinessWebsite = true;
        delete aboutBusinessForm.businessUrl;
        sessionStorage.setItem(
          "aboutBusinessForm",
          JSON.stringify(aboutBusinessForm)
        );

        setNoBusinessWebsite(true);
        setBusinessUrl("");
        return;
      }

      // Normalize (https://domain.com)
      const normalized = normalizeWebsite(rawWebsite);
      if (!normalized) {
        // Domain sahi format me nahi hai → user ko EditBusinessDetail pe handle karne do
        return;
      }

      setNoBusinessWebsite(false);
      setBusinessUrl(normalized);

      aboutBusinessForm.businessUrl = normalized;
      aboutBusinessForm.noBusinessWebsite = false;
      sessionStorage.setItem(
        "aboutBusinessForm",
        JSON.stringify(aboutBusinessForm)
      );
      sessionStorage.setItem("businessUrl", normalized);

      // 🔹 Validate website
      const result = await validateWebsite(normalized);
      if (!result?.valid) {
        // Validation fail ho gaya → user baad me EditBusinessDetail pe manually change kar sakta hai
        setIsVerified(false);
        return;
      }

      setIsVerified(true);

      const res = await listSiteMap(normalized);
      const urls = res?.urls || [];
      sessionStorage.setItem("urls", JSON.stringify(urls));

      const formatted = urls.map((u, index) => ({
        url: u,
        checkedStatus: index < 10,
      }));

      sessionStorage.setItem("scrapedUrls", JSON.stringify(formatted));
      sessionStorage.setItem(
        "refreshSelectedSiteMapUrls",
        JSON.stringify(formatted)
      );
      sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(formatted));
      sessionStorage.setItem("lastSitemapDomain", normalized);

      window.dispatchEvent(new Event("sitemapSelectionUpdated"));
    } catch (err) {
      console.error("Auto website validate/listSiteMap failed:", err);
    }
  };

  const safeJSONParse = (val, fallback) => {
    try {
      if (!val) return fallback;
      if (val === "[object Object]") return fallback;
      return JSON.parse(val);
    } catch {
      return fallback;
    }
  };

  //new
  // Normalization util (copied from AboutBusiness)
  const normalizeWebsite = (raw) => {
    if (!raw) return "";
    try {
      let v = String(raw)
        .trim()
        .replace(/https?:\/\/(www\.)?/i, "");
      v = v.split("/")[0].toLowerCase().replace(/\s+/g, "");
      if (!v) return "";
      const domainRegex = /^[\w-]+(\.[\w-]{2,})+$/i;
      if (!domainRegex.test(v)) return "";
      return "https://" + v; // no www
    } catch {
      return "";
    }
  };

  // Autofill website from Google Place (same behaviour as AboutBusiness)
  const maybeAutofillWebsite = (place) => {
    // ❗ Never autofill if user said they don't have a website
    if (noBusinessWebsiteRef.current) return;

    const normalized = normalizeWebsite(place?.website);
    const isNewPlace = prevPlaceIdRef.current !== place?.place_id;
    const shouldOverwrite =
      isNewPlace ||
      !businessUrl ||
      businessUrl === HTTPS_PREFIX ||
      businessUrl === lastAutoFilledUrlRef.current;

    if (shouldOverwrite) {
      if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

      if (normalized) {
        setBusinessUrl(normalized);
        lastAutoFilledUrlRef.current = normalized;
        handleUrlVerification(normalized);
      } else {
        setBusinessUrl("");
        setIsVerified(null);
        setBusinessUrlError("");
        sessionStorage.removeItem("businessUrl");
      }
    }
    if (noBusinessWebsite) return;
    if (!placeDetails?.website) return;

    prevPlaceIdRef.current = place?.place_id || null;
  };

  // Debounce manual typing verification (500ms)
  const scheduleVerify = (final, v) => {
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    const domainRegex = /^[\w-]+(\.[\w-]{2,})+$/i;
    typingTimeoutRef.current = setTimeout(() => {
      if (domainRegex.test(v)) {
        handleUrlVerification(final);
      }
    }, 500);
  };

  const initAutocomplete = () => {
    const autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("google-autocomplete"),
      {
        types: ["establishment"],
        fields: ["place_id", "name", "url"],
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.place_id) {
        const businessUrl = place.url;
        const businessName = place.name;
        setGoogleListing(businessUrl);
        setDisplayBusinessName(businessName);
        sessionStorage.setItem("googleListing", businessUrl);
        setcurrentForm((prev) => ({
          ...prev,
          googleListing: businessUrl,
        }));
        sessionStorage.setItem("displayBusinessName", businessName);
        fetchPlaceDetails(place.place_id);
      }
    });
  };

  function extractAddressFields(addressComponents) {
    const getComponent = (
      primaryType,
      fallbackType = null,
      useShort = false
    ) => {
      const comp = addressComponents.find(
        (c) =>
          c.types.includes(primaryType) ||
          (fallbackType && c.types.includes(fallbackType))
      );
      return comp ? (useShort ? comp.short_name : comp.long_name) : "";
    };
    return {
      city: getComponent("locality", "sublocality_level_1"),
      state: getComponent("administrative_area_level_1"),
      country: getComponent("country"),
      postal_code: getComponent("postal_code"),
      street_number: getComponent("street_number"),
      state_code: getComponent("administrative_area_level_1", null, true),
      country_code: getComponent("country", null, true),
    };
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google?.maps?.places) {
        initAutocomplete();
        clearInterval(interval);
      }
    }, 300);
  }, []);

  useEffect(() => {
    if (EditingMode === "ON" && !noBusinessWebsite) {
      handleBlur();
    }
  }, [EditingMode, noBusinessWebsite]);

  const fetchPlaceDetails = (placeId) => {
    setLoading(true);
    if (prevPlaceIdRef.current && prevPlaceIdRef.current !== placeId) {
      sessionStorage.removeItem("urls");
      sessionStorage.removeItem("scrapedUrls");
      sessionStorage.removeItem("selectedSiteMapUrls");
      sessionStorage.removeItem("refreshSelectedSiteMapUrls");
      sessionStorage.removeItem("lastSitemapDomain");
    }
    prevPlaceIdRef.current = placeId;
    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );
    service.getDetails(
      {
        placeId,
        fields: [
          "place_id",
          "name",
          "url",
          "website",
          "formatted_address",
          "international_phone_number",
          "formatted_phone_number",
          "opening_hours",
          "rating",
          "user_ratings_total",
          "business_status",
          "types",
          "address_components",
        ],
      },
      (result, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setPlaceDetails(result);
          generateGoogleListingUrl(result);
          const form1 = JSON.parse(
            sessionStorage.getItem("placeDetailsExtract") || "{}"
          );
          const addressFields = extractAddressFields(
            result?.address_components || []
          );

          const businessData = {
            businessName: result.name || "",
            address: result.formatted_address || "",
            phone:
              result.international_phone_number ||
              result.formatted_phone_number ||
              "",
            internationalPhone: result.international_phone_number || "",
            website: result.website || "",
            rating: result.rating || "",
            totalRatings: result.user_ratings_total || "",
            hours: result.opening_hours?.weekday_text || [],
            businessStatus: result.business_status || "",
            categories: result.types || [],
            street_number: addressFields.street_number || "",
            city: addressFields.city,
            state: addressFields.state,
            country: addressFields.country,
            postal_code: addressFields.postal_code,
            state_code: addressFields.state_code,
            country_code: addressFields.country_code,
          };

          autoHandleWebsiteFromPlace(result);

          const updatedForm = {
            ...form1,
            ...businessData,
          };
          sessionStorage.setItem(
            "placeDetailsExtract",
            JSON.stringify(updatedForm)
          );
          const modalDetails = {
            businessName: businessData.businessName,
            address: businessData.address,
            phone: businessData.phone,
            businessEmail: form1?.businessEmail || form1?.email || "",
            website: businessData.website,
          };
          setBusinessDetails(modalDetails);
          setBusinessDetailsConfirmPopup(true);
          maybeAutofillWebsite(result);
        } else {
          console.error("Place details fetch failed:", status);
        }
        setLoading(false);
      }
    );
  };

  const generateGoogleListingUrl = (place) => {
    const address = [
      place.address_components.find((c) => c.types.includes("street_number"))
        ?.long_name,
      place.address_components.find((c) => c.types.includes("route"))
        ?.long_name,
      place.address_components.find((c) => c.types.includes("premise"))
        ?.long_name,
      place.address_components.find((c) => c.types.includes("subpremise"))
        ?.long_name,
      place.address_components.find((c) =>
        c.types.includes("sublocality_level_1")
      )?.long_name,
      place.address_components.find((c) => c.types.includes("locality"))
        ?.long_name,
      place.address_components.find((c) =>
        c.types.includes("administrative_area_level_2")
      )?.long_name,
      place.address_components.find((c) =>
        c.types.includes("administrative_area_level_1")
      )?.long_name,
    ]
      .filter(Boolean)
      .join(" ");

    const googleLink = `https://www.google.com/search?q=${encodeURIComponent(
      place.name + " " + address
    )}`;
    setGoogleListing(googleLink);
  };

  const handleUrlVerification = async (url) => {
    if (noBusinessWebsiteRef.current) return;
    setUrlVerificationInProgress(true);
    const result = await validateWebsite(url);
    if (noBusinessWebsiteRef.current) {
      setUrlVerificationInProgress(false);
      return;
    }

    if (result.valid) {
      setIsVerified(true);
      setBusinessUrlError("");
      const canonical = normalizeWebsite(url) || url;
      setBusinessUrl(canonical);
      sessionStorage.setItem("businessUrl", canonical);
      localStorage.setItem("isVerified", true);

      const scrapedUrls = JSON.parse(
        sessionStorage.getItem("scrapedUrls") || "[]"
      );
      if (
        originalForm?.businessUrl !== businessUrl ||
        scrapedUrls.length === 0
      ) {
        const res = await listSiteMap(url);
        const filteredUrls = filterCompanyPages(res.urls);
        if (!filteredUrls.includes(url)) filteredUrls.unshift(url);
        setcurrentForm((prev) => ({ ...prev, siteMapUrls: filteredUrls }));
        setShowSiteMapUrls(filteredUrls);
        const formatted = filteredUrls.map((u, index) => ({
          url: u,
          checkedStatus: index < 10,
        }));
        setAddOnUrl(url);
        sessionStorage.setItem("scrapedUrls", JSON.stringify(formatted));
      } else {
        const urls = JSON.parse(sessionStorage.getItem("scrapedUrls")) || [];
        setShowSiteMapUrls(urls);
      }
    } else {
      setIsVerified(false);
      setBusinessUrlError("Invalid URL");
      localStorage.setItem("isVerified", false);
      if (url?.trim()) shouldFocusBackRef.current = true;
    }
    setUrlVerificationInProgress(false);
  };

  useEffect(() => {
    const savedVerifiedStatus = localStorage.getItem("isVerified");
    if (savedVerifiedStatus !== null) {
      setIsVerified(savedVerifiedStatus === "true");
    }
  }, []);

  const handleBlur = () => {
    if (businessUrl?.trim()) {
      handleUrlVerification(businessUrl);
    }
  };

  const handleInputChange = (e) => {
    setIsInitialLoad(false);
    lastAutoFilledUrlRef.current = "";
    setIsVerified(false);
    let v = e.target.value.trim();
    v = v.replace(/^https?:\/\//i, "");
    v = v.split("/")[0];
    v = v.replace(/\s+/g, "").toLowerCase();
    const final = HTTPS_PREFIX + v;
    setBusinessUrl(final);
    setcurrentForm((prev) => ({ ...prev, businessUrl: final }));
    setNoBusinessWebsite(false);
    if (businessUrlError) setBusinessUrlError("");
    scheduleVerify(final, v);
  };

  // Prevent deleting the forced prefix (like AboutBusiness)
  const handleWebsiteKeyDown = (e) => {
    const { key, target } = e;
    if (key !== "Backspace" && key !== "Delete") return;
    const { selectionStart, selectionEnd, value } = target;
    const fullSelection =
      selectionStart === 0 && selectionEnd === value?.length;

    if (fullSelection) {
      e.preventDefault();
      setBusinessUrl(HTTPS_PREFIX);
      requestAnimationFrame(() =>
        target.setSelectionRange(PREFIX_LEN, PREFIX_LEN)
      );
      return;
    }
    if (selectionStart <= PREFIX_LEN) e.preventDefault();
  };

  // Focus back after invalid attempt
  useEffect(() => {
    if (!businessUrl || businessUrl.length <= PREFIX_LEN) {
      shouldFocusBackRef.current = false;
      return;
    }
    if (shouldFocusBackRef.current) {
      inputRefWebSiteUrl.current?.focus();
      shouldFocusBackRef.current = false;
    }
  }, [businessUrl]);

  useEffect(() => {
    if (token) setUserId(decodeTokenData.id || "");
  }, [token]);

  useEffect(() => {
    if (localStorage.getItem("UpdationMode") == "ON") {
      const savedData = safeJSONParse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );

      setOriginalForm({
        googleListing: savedData.googleListing || "",
        businessUrl: savedData.businessUrl || "",
        isWebsiteUrl: savedData.businessUrl ? 1 : 0,
        isGoogleListing: savedData.googleListing ? 1 : 0,
        siteMapUrls: safeJSONParse(sessionStorage.getItem("scrapedUrls") || "[]"),
      });
      // Main
      setcurrentForm({
        googleListing: savedData.googleListing || "",
        businessUrl: savedData.businessUrl || "",
        isWebsiteUrl: savedData.businessUrl ? 1 : 0,
        isGoogleListing: savedData.googleListing ? 1 : 0,
        siteMapUrls: safeJSONParse(sessionStorage.getItem("scrapedUrls") || "[]"),
      });

      if (!savedData.noBusinessWebsite && savedData.businessUrl) {
        setBusinessUrl(savedData.businessUrl);
      }
      if (savedData.googleListing) setGoogleListing(savedData.googleListing);

      if (typeof savedData.noGoogleListing === "boolean")
        setNoGoogleListing(savedData.noGoogleListing);
      if (typeof savedData.noBusinessWebsite === "boolean")
        setNoBusinessWebsite(savedData.noBusinessWebsite);
    } else {
      const savedData = safeJSONParse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      if (savedData) {
        if (!savedData.noBusinessWebsite && savedData.businessUrl) {
          setBusinessUrl(savedData.businessUrl);
        }
        if (typeof savedData.noBusinessWebsite === "boolean")
          setNoBusinessWebsite(savedData.noBusinessWebsite);
      }
    }
  }, []);

  useEffect(() => {
    if (noBusinessWebsite) {
      setBusinessUrl("");
      setIsVerified(false);
      setBusinessUrlError("");
      sessionStorage.removeItem("businessUrl");
    }
  }, [noBusinessWebsite]);

  useEffect(() => {
    const aboutBusinessForm = JSON.parse(
      sessionStorage.getItem("aboutBusinessForm") || "{}"
    );
    if (EditingMode == "ON") {
      const noListing =
        !aboutBusinessForm.googleListing?.trim() && !googleListing?.trim();
      const noWebsite =
        !aboutBusinessForm.businessUrl?.trim() && !businessUrl?.trim();

      if (noListing) {
        setNoGoogleListing(true);
        aboutBusinessForm.noGoogleListing = true;
        sessionStorage.setItem(
          "aboutBusinessForm",
          JSON.stringify(aboutBusinessForm)
        );
      }

      if (noWebsite) {
        setNoBusinessWebsite(true);
        setIsVerified(true);
        aboutBusinessForm.noBusinessWebsite = true;
        sessionStorage.setItem(
          "aboutBusinessForm",
          JSON.stringify(aboutBusinessForm)
        );
      }
    } else {
      if (aboutBusinessForm.noGoogleListing === true) setNoGoogleListing(true);
      else setNoGoogleListing(false);

      if (aboutBusinessForm.noBusinessWebsite === true) {
        setNoBusinessWebsite(true);
        setIsVerified(true);
      } else setNoBusinessWebsite(false);
    }
  }, [googleListing, businessUrl]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google?.maps?.places) {
        const input = document.getElementById("google-autocomplete");
        if (input) {
          initAutocomplete();
          clearInterval(interval);
        }
      }
    }, 300);
  }, []);

  // Prefill from saved place details (parity with AboutBusiness)
  useEffect(() => {
    if (noBusinessWebsite) return;
    const place = JSON.parse(
      sessionStorage.getItem("placeDetailsExtract") || "{}"
    );
    if (!businessUrl && place?.website) {
      const normalized = normalizeWebsite(place.website);
      if (normalized) {
        setBusinessUrl(normalized);
        handleUrlVerification(normalized);
      }
    }
  }, []);

  // If placeDetails updates and has a website, autofill it (parity with AboutBusiness)
  useEffect(() => {
    if (noBusinessWebsite) return;
    if (!placeDetails?.website) return;
    const normalized = normalizeWebsite(placeDetails.website);
    if (normalized && (!businessUrl || businessUrl === HTTPS_PREFIX)) {
      setBusinessUrl(normalized);
      handleUrlVerification(normalized);
    }
  }, [placeDetails, noBusinessWebsite]);

  const saveFormAndGoNext = () => {
    const existing = JSON.parse(
      sessionStorage.getItem("aboutBusinessForm") || "{}"
    );

    sessionStorage.setItem(
      "aboutBusinessForm",
      JSON.stringify({
        ...existing,
        businessUrl,
        googleListing,
        noGoogleListing,
        noBusinessWebsite,
      })
    );

    navigate("/edit-business-detail", { state: { isChanged: true } });
  };

  const handleContinue = (e) => {
    e.preventDefault();

    const isGoogleListingValid = googleListing.trim();
    if (!isGoogleListingValid && !noGoogleListing) {
      setPopupType("failed");
      setPopupMessage(
        "Please provide a Google Listing or check the box if you don't have one."
      );
      setShowPopup(true);
      return;
    }
    saveFormAndGoNext();
  };

  const handleConfirmBusinessDetails = (status) => {
    if (status) {
      setDisableLoading(true);

      setTimeout(() => {
        setDisableLoading(false);
        setBusinessDetailsConfirmPopup(false);
        saveFormAndGoNext();
      }, 4000);
    } else {
      setBusinessDetailsConfirmPopup(false);
    }
  };

  const isFormChanged = () => {
    if (!originalForm || !currentForm) return false;
    if (originalForm.businessUrl !== currentForm.businessUrl) return true;
    if (originalForm.googleListing !== currentForm.googleListing) return true;
    if (originalForm.displayBusinessName !== currentForm.displayBusinessName)
      return true;
    if (originalForm.isWebsiteUrl !== currentForm.isWebsiteUrl) return true;
    if (originalForm.isGoogleListing !== currentForm.isGoogleListing)
      return true;
    const origUrls = originalForm.siteMapUrls || [];
    const currUrls = currentForm.siteMapUrls || [];
    if (origUrls.length !== currUrls.length) return true;
    for (let i = 0; i < origUrls.length; i++) {
      if (
        origUrls[i].url !== currUrls[i].url ||
        origUrls[i].checkedStatus !== currUrls[i].checkedStatus
      )
        return true;
    }
    return false;
  };

  useEffect(() => {
    const sessionSelected = safeJSONParse(
      sessionStorage.getItem("selectedSiteMapUrls"),
      []
    );

    if (sessionSelected.length > 0) {
      const checkedUrls = sessionSelected
        .filter((item) => item.checkedStatus)
        .map((item) => item.url);
      setSelectedUrls(checkedUrls);
    }
  }, [showSiteMapUrls]);

  const updateStoredForm = (changes) => {
    const form = JSON.parse(
      sessionStorage.getItem("aboutBusinessForm") || "{}"
    );
    Object.assign(form, changes);
    sessionStorage.setItem("aboutBusinessForm", JSON.stringify(form));
  };

  const handleConfirmNoGMB = () => {
    setShowPopup(false);

    setNoGoogleListing(true);
    setGoogleListing("");
    setDisplayBusinessName("");

    updateStoredForm({
      googleListing: "",
      displayBusinessName: "",
      noGoogleListing: true,
    });

    sessionStorage.removeItem("googleListing");
    sessionStorage.removeItem("displayBusinessName");
  };

  const scrollListIntoView = () => {
    if (listRef.current) {
      listRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <>
      <EditHeader title="Edit Agent " agentName={agentnm} />
      <div className={styles.Maindiv}>
        <SectionHeader
          heading="Public Listing"
          subheading="Enter your Google My Business Listing & Website"
        />
      </div>

      <div className={styles.container} ref={listRef}>
        <div className={styles.inputSection}>
          <label className={styles.label}>Google My Business</label>
          <CustomAutoSearch
            value={displayBusinessName}
            placeholder="Type the name of your Business to Search"
            disabled={noGoogleListing}
            required={true}
            results={googleResults}
            fetchResults={fetchGoogleResults}
            onChange={(value) => {
              setDisplayBusinessName(value);
              setcurrentForm((prev) => ({
                ...prev,
                displayBusinessName: value,
              }));

              if (value.trim().length > 0) {
                setShowNoGMBCheckbox(true);
                sessionStorage.setItem("showNoGMBCheckbox", "true");
              }

              fetchGoogleResults(value);
              setTimeout(scrollListIntoView, 300);
            }}
            onFocus={() => setTimeout(scrollListIntoView, 300)}
            onClick={() => setTimeout(scrollListIntoView, 300)}
            onSelect={(item) => {
              const name =
                item?.structured_formatting?.main_text || item?.description;

              setDisplayBusinessName(name);
              sessionStorage.setItem("displayBusinessName", name);
              setGoogleResults([]);

              // Generate Google search URL
              const googleLink = `https://www.google.com/search?q=${encodeURIComponent(
                item.description
              )}`;
              setGoogleListing(googleLink);
              sessionStorage.setItem("googleListing", googleLink);

              setcurrentForm((prev) => ({
                ...prev,
                googleListing: googleLink,
                displayBusinessName: name,
              }));

              // Fetch Google details exactly like AboutBusiness
              fetchPlaceDetails(item.place_id);
            }}
          />
        </div>
        {
          <label className={styles.checkboxContainer}>
            <input
              type="checkbox"
              checked={noGoogleListing}
              onChange={(e) => {
                const checked = e.target.checked;
                if (checked) {
                  setPopupType("confirm");
                  setPopupMessage(
                    "Are you sure you don't have Google My Business listing?"
                  );
                  setShowPopup(true);
                } else {
                  setNoGoogleListing(false);
                  updateStoredForm({ noGoogleListing: false });
                }
              }}
            />
            <span className={styles.customCheckbox}></span>I do not have Google
            My Business Listing
          </label>
        }

        <hr className={styles.separator} />

        <div
          className={styles.stickyWrapper}
          onClick={handleContinue}
          style={{
            pointerEvents: isFormChanged() ? "auto" : "none",
            opacity: isFormChanged() ? 1 : 0.5,
          }}
        >
          <AnimatedButton
            label="Save"
            disabled={!isFormChanged() || urlVerificationInProgress}
          />
        </div>

        {showPopup && (
          <PopUp
            type={popupType}
            message={popupMessage}
            onClose={() => {
              setShowPopup(false);
            }}
            onConfirm={popupType === "confirm" ? handleConfirmNoGMB : undefined}
          />
        )}

        {businessDetailsConfirmPopup && (
          <Modal2
            disabled={disableLoading}
            className={stepStyles.disableModal}
            isOpen={businessDetailsConfirmPopup}
            onClose={() => setBusinessDetailsConfirmPopup(false)}
            type="info"
          >
            <div
              className={`${stepStyles.gmbWrapper} ${
                disableLoading ? stepStyles.disabledCard : ""
              }`}
            >
              <h2 className={stepStyles.gmbTitle}>
                Confirm your <br /> Google Business listing
              </h2>

              <div className={stepStyles.gmbInfoBox}>
                <div className={stepStyles.gmbRow}>
                  <span className={stepStyles.label}>Business Name</span>
                  <span
                    className={stepStyles.value}
                    title={businessDetails?.businessName || ""}
                  >
                    {businessDetails?.businessName || "-"}
                  </span>
                </div>

                <div className={stepStyles.gmbRow}>
                  <span className={stepStyles.label}>Phone Number</span>
                  <span
                    className={stepStyles.value}
                    title={businessDetails?.phone || ""}
                  >
                    {businessDetails?.phone || "-"}
                  </span>
                </div>

                <div className={stepStyles.gmbRow}>
                  <span className={stepStyles.label}>Address</span>
                  <span
                    className={stepStyles.value}
                    title={businessDetails?.address || ""}
                  >
                    {businessDetails?.address || "-"}
                  </span>
                </div>

                <div className={stepStyles.gmbRow}>
                  <span className={stepStyles.label}>Business Email</span>
                  <span
                    className={stepStyles.value}
                    title={businessDetails?.businessEmail || ""}
                  >
                    {businessDetails?.businessEmail || "-"}
                  </span>
                </div>

                <div className={stepStyles.gmbRow}>
                  <span className={stepStyles.label}>Website</span>
                  <span
                    className={stepStyles.value}
                    title={businessDetails?.website || ""}
                  >
                    {businessDetails?.website || "-"}
                  </span>
                </div>
              </div>

              <div className={stepStyles.gmbActions}>
                <button
                  className={stepStyles.btnGrey}
                  onClick={() => handleConfirmBusinessDetails(false)}
                >
                  <img src="/svg/btn-gray-shape.svg" alt="btn-gray-shape" />
                  <p>NO, Incorrect</p>
                </button>

                <button
                  className={stepStyles.btnPrimary}
                  disabled={disableLoading}
                  onClick={() => handleConfirmBusinessDetails(true)}
                >
                  <img src="/svg/btn-purpol-shape.svg" alt="btn-gray-shape" />
                  {disableLoading ? (
                    <p className={stepStyles.text}>Processing...</p>
                  ) : (
                    <p className={stepStyles.text}>Yes, It's Mine</p>
                  )}
                </button>
              </div>
            </div>
          </Modal2>
        )}
      </div>
    </>
  );
};

export default EditPublic;
